
import { Component, Prop, Vue } from "vue-property-decorator";

@Component({
  components: {},
})
export default class BackgroundCircle extends Vue {
  @Prop({ required: true }) private position!: "top" | "bottom";
}
